import * as z from "zod";
import { requiredString } from "components/form/utils";

export const categorySchema = z.object({
  name: requiredString(),
});
